<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="container border rounded" style="background-color:powderblue;">
      <div class="row justify-content-md-center">
        <span *ngIf="Item.ID != -1 && inoDrzava == false">{{Item.SNaziv + ", " + mestoNaziv + ", " +
          drzavaNaziv}}</span>
        <span *ngIf="Item.ID != -1 && inoDrzava == true">{{Item.SNaziv + ", " + Item.InoMesto + ", " +
          drzavaNaziv}}</span>
        <span *ngIf="Item.ID == -1" translate="KOMITENT.NEW.SINGULAR"></span>
      </div>
    </div>
    <div class="row tabs-cont" #tabsCont>
      <div class="col-md-12 h-100">
        <ngb-tabset #tabSet="ngbTabset" [destroyOnHide]="false" id="tabset">
          <ngb-tab title="{{'KOMITENT.BASIC'| translate}}" id="tbList">
            <ng-template ngbTabContent>
              <div class="form-group row">
                <!-- <label class="col-form-label col-2"><span translate="KOMITENT.NAZIV.SINGULAR"></span></label> -->
                <div class="col-md-12">
                  <yt-input [Type]="'text'" name="txtNaziv" formControlName="Naziv" #focusElement [MaxLength]="200"
                    [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}" [Label]="'KOMITENT.NAZIV.SINGULAR'"
                    #autofocus>
                  </yt-input>
                  <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
                    <span *ngFor="let validation of errorMessages.Naziv">
                      <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span
                          translate="{{validation.message}}"></span></span>
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-9">
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-2"><span translate="KOMITENT.SNAZIV.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtSnaziv" formControlName="SNaziv" [MaxLength]="100"
                        [ngClass]="{'is-invalid': submitted && fc.SNaziv.invalid}" [Label]="'KOMITENT.SNAZIV.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.SNaziv.invalid">
                        <span *ngFor="let validation of errorMessages.SNaziv">
                          <span class="error-message" *ngIf="fc.SNaziv.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group row">
                    <!-- <label class="col-form-label col-2"><span translate="KOMITENT.VRSTAKOMITENTAID.SINGULAR"></span></label> -->
                    <div class="col-md-12">
                      <yt-dropdown-picklist [ModelName]="'vrstakomitenta'" [GetName]="'get'" [ModelProperty]="'Naziv'"
                        formControlName="VrstaKomitentaID" [Label]="'KOMITENT.VRSTAKOMITENTA.SINGULAR'"
                        [Position]="'left'" [Required]="false" [AllowAddNew]="true"
                        ngbTooltip="{{'KOMITENT.VRSTAKOMITENTA.TOOLTIP' | translate }}">
                      </yt-dropdown-picklist>
                      <!-- <div class="form-error" *ngIf="submitted && fc.VrstaKomitentaID.invalid">
                                              <span *ngFor="let validation of errorMessages.VrstaKomitentaID">
                                                <span class="error-message" *ngIf="fc.VrstaKomitentaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                                              </span>
                                          </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <!-- <label class="col-form-label col-2"><span translate="KOMITENT.VRSTAKOMITENTAID.SINGULAR"></span></label> -->
                <div class="col-md-6">
                  <yt-dropdown-picklist [ModelName]="'tipkomitenta'" [GetName]="'get'" [ModelProperty]="'Naziv'"
                                        formControlName="TipKomitentaID" [Label]="'KOMITENT.TIPKOMITENTA.SINGULAR'" [Position]="'left'"
                                        [AllowAddNew]="false" (OnItemSelected)="onTipKomitentaSelect($event)">
                  </yt-dropdown-picklist>
                  <div class="form-error" *ngIf="submitted && this.baseFormGroup.invalid">
                    <span class="error-message"
                          *ngIf="this.baseFormGroup.errors && this.baseFormGroup.errors.checkControls && !this.baseFormGroup.errors.checkControls.valid">
                      <span translate="{{this.baseFormGroup.errors.checkControls.message}}"></span>
                    </span>
                  </div>
                  <div class="form-error" *ngIf="submitted && fc.TipKomitentaID.invalid">
                    <span *ngFor="let validation of errorMessages.TipKomitentaID">
                      <span class="error-message" *ngIf="fc.TipKomitentaID.hasError(validation.type)">
                        <span translate="{{validation.message}}"></span>
                      </span>
                    </span>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input"
                               type="checkbox"
                               formControlName="ZaCrf"
                               id="chkZaCrf">
                        <label class="form-check-label" for="chkZaCrf" ngbTooltip="{{'KOMITENT.ZACRF.TOOLTIP' | translate }}">
                          <span translate="KOMITENT.ZACRF.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input"
                               type="checkbox"
                               formControlName="is_active"
                               id="chkis_active">
                        <label class="form-check-label" for="chkis_active" ngbTooltip="{{'KOMITENT.ZACRF.TOOLTIP' | translate }}">
                          <span translate="Aktivan" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="row">
                <!-- <label class="col-form-label col-2"><span translate="KOMITENT.PIB.SINGULAR"></span></label> -->
                <div class="col-lg-4 col-md-4">
                  <div class="form-group row">
                    <div class="col-lg-10 col-md-9 col-9">
                      <yt-input [Type]="'text'" name="txtPib" formControlName="Pib" [MaxLength]="9"
                        [ngClass]="{'is-invalid': submitted && fc.Pib.invalid}" [Label]="'KOMITENT.PIB.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Pib.invalid">
                        <span *ngFor="let validation of errorMessages.Pib">
                          <span class="error-message" *ngIf="fc.Pib.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                    <!-- <div class="col-lg-1 col-md-2 col-2 input-group-append pl-0 justify-content-end">
                          <span class="input-group-append">
                              <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.PIB.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetCompanyDataByPib()" ><span class="fa fa-fw fa-download"></span></button>
                          </span>
                      </div> -->
                    <div class="col-lg-2 col-md-3 col-3 pl-0 justify-content-end" [hidden]="this.Item.ID > -1">
                      <span class="input-group-append">
                        <!-- <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.PIB.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetCompanyDataByPibNovo()" [disabled]="loadingCompanyDataByPib" >
                              <span *ngIf="!loadingCompanyDataByPib" class="fas fa-fw fa-cloud-download-alt"></span>
                              <span *ngIf="loadingCompanyDataByPib" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                            </button>  -->

                        <yt-button [Class]="'btn btn-secondary'" [NgbTooltip]="'NBS.PIB.TOOLTIP'" [Placement]="'top'"
                          [Container]="'body'" (clicked)="GetCompanyDataByPibNovo($event)"
                          [IsDisabled]="loadingCompanyDataByPib" [Model]="'komitent'" [Action]="'pibNBS'">
                          <span *ngIf="!loadingCompanyDataByPib" class="fas fa-fw fa-cloud-download-alt"></span>
                          <span *ngIf="loadingCompanyDataByPib" class="loader"><span
                              class="fa fa-spinner fa-spin"></span></span>
                        </yt-button>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- <label class="col-form-label col-2"><span translate="KOMITENT.MATICNIBROJ.SINGULAR"></span></label> -->
                <div class="col-lg-4 col-md-4">
                  <div class="form-group row">
                    <div class="col-lg-10 col-md-9 col-9">
                      <yt-input [Type]="'text'" name="txtMatbr" formControlName="MaticniBroj" [MaxLength]="8"
                        [ngClass]="{'is-invalid': submitted && fc.MaticniBroj.invalid}"
                        [Label]="'KOMITENT.MATICNIBROJ.SINGULAR'" [addLeadingZeros]="8">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.MaticniBroj.invalid">
                        <span *ngFor="let validation of errorMessages.MaticniBroj">
                          <span class="error-message" *ngIf="fc.MaticniBroj.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                    <!-- <div class="col-lg-1 col-md-2 col-2 input-group-append pl-0 justify-content-end">
                          <span class="input-group-append">
                              <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.MATICNIBROJ.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetCompanyDataByMatBr()" ><span class="fa fa-fw fa-download"></span></button> 
                          </span>
                      </div>  -->
                    <div class="col-lg-2 col-md-3 col-3 pl-0 justify-content-end" [hidden]="this.Item.ID > -1">
                      <span class="input-group-append">
                        <!-- <button type="button" class="btn btn-secondary" ngbTooltip="{{'NBS.MATICNIBROJ.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetCompanyDataByMatBrNovo()" [disabled]="loadingCompanyDataByMB">
                              <span *ngIf="!loadingCompanyDataByMB" class="fas fa-fw fa-cloud-download-alt"></span>
                              <span *ngIf="loadingCompanyDataByMB" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                            </button>  -->
                        <yt-button [Class]="'btn btn-secondary'" [NgbTooltip]="'NBS.MATICNIBROJ.TOOLTIP'"
                          [Placement]="'top'" [Container]="'body'" (clicked)="GetCompanyDataByMatBrNovo($event)"
                          [IsDisabled]="loadingCompanyDataByMB" [Model]="'komitent'" [Action]="'maticniBrojNBS'">
                          <span *ngIf="!loadingCompanyDataByMB" class="fas fa-fw fa-cloud-download-alt"></span>
                          <span *ngIf="loadingCompanyDataByMB" class="loader"><span
                              class="fa fa-spinner fa-spin"></span></span>
                        </yt-button>
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4">                    
                      <div class="form-group row">
                          <div class="col-lg-12 col-md-12 col-12">                            
                            <yt-input
                            [Type]="'text'"
                            name="txtJbkjs"
                            formControlName="Jbkjs"
                            [MaxLength]="5"
                            [ngClass]="{'is-invalid': submitted && fc.Jbkjs.invalid}"
                            [Label]="'KOMITENT.JBKJS.SINGULAR'"
                            ngbTooltip="{{'KOMITENT.JBKJS.TOOLTIP' | translate }}">
                          </yt-input>
                          <div class="form-error" *ngIf="submitted && fc.Jbkjs.invalid">
                              <span *ngFor="let validation of errorMessages.Jbkjs">
                                <span class="error-message" *ngIf="fc.Jbkjs.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                              </span>
                          </div>
                          <!-- <div class="col-lg-2 col-md-3 col-3 input-group-append pl-0 justify-content-end" [hidden]="this.Item.ID > -1">
                            <span class="input-group-append">
                                <button type="button" class="btn btn-secondary" ngbTooltip="{{'KJS.JBKJS.TOOLTIP' | translate }}" placement="top" container="body" (click)="GetJbkjsDataByPib()" [disabled]="loadingJbkjsDataByPib">
                                  <span *ngIf="!loadingJbkjsDataByPib" class="fas fa-fw fa-cloud-download-alt"></span>
                                  <span *ngIf="loadingJbkjsDataByPib" class="loader"><span class="fa fa-spinner fa-spin"></span></span>
                                </button> 
                            </span>
                        </div>  -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <!-- <label class="col-form-label col-2"><span translate="KOMITENT.PIB.SINGULAR"></span></label> -->
                <div class="col-md-3">
                  <div class="form-group row">
                    <div class="col-lg-12 col-md-12 col-12">
                      <yt-input [Type]="'text'" name="txtJmbg" formControlName="Jmbg" [MaxLength]="13"
                        [ngClass]="{'is-invalid': submitted && fc.Jmbg.invalid}" [Label]="'KOMITENT.JMBG.SINGULAR'">
                      </yt-input>
                      <div class="form-error"
                        *ngIf="(fc.Jmbg.invalid && fc.Jmbg.dirty) || (submitted && fc.Jmbg.invalid)">
                        <span *ngFor="let validation of errorMessages.Jmbg">
                          <span class="error-message" *ngIf="fc.Jmbg.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group row">
                    <div class="col-lg-12 col-md-12 col-12">
                      <yt-input [Type]="'text'" name="txtBrojGazdinstva" formControlName="BrojGazdinstva"
                        [MaxLength]="30" [ngClass]="{'is-invalid': submitted && fc.BrojGazdinstva.invalid}"
                        [Label]="'KOMITENT.BROJGAZDINSTVA.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.BrojGazdinstva.invalid">
                        <span *ngFor="let validation of errorMessages.BrojGazdinstva">
                          <span class="error-message" *ngIf="fc.BrojGazdinstva.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group row">
                    <div class="col-lg-12 col-md-12 col-12">
                      <yt-input
                        [Type]="'text'"
                        name="txtImeOca"
                        formControlName="ImeOca"
                        [MaxLength]="50"
                        [ngClass]="{'is-invalid': submitted && fc.ImeOca.invalid}"
                        [Label]="'KOMITENT.IMEOCA.SINGULAR'"
                        ngbTooltip="{{'KOMITENT.IMEOCA.TOOLTIP' | translate }}">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.ImeOca.invalid">
                        <span *ngFor="let validation of errorMessages.ImeOca">
                          <span class="error-message" *ngIf="fc.ImeOca.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group row">
                    <div class="col-lg-12 col-md-12 col-12">
                      <yt-input
                        [Type]="'text'"
                        name="txtBrojLicneKarte"
                        formControlName="BrojLicneKarte"
                        [MaxLength]="9"
                        [ngClass]="{'is-invalid': submitted && fc.BrojLicneKarte.invalid}"
                        [Label]="'KOMITENT.BROJLICNEKARTE.SINGULAR'"
                        ngbTooltip="{{'KOMITENT.BROJLICNEKARTE.TOOLTIP' | translate }}">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.BrojLicneKarte.invalid">
                        <span *ngFor="let validation of errorMessages.BrojLicneKarte">
                          <span class="error-message" *ngIf="fc.BrojLicneKarte.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row mt-2">
                <div class="col-md-2">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <div class="form-check" style="padding-top: 22px">
                        <input class="form-check-input" type="checkbox" formControlName="PdvUSistemu"
                          id="chkUPdvSistemu">
                        <label class="form-check-label" for="chkUPdvSistemu">
                          <span translate="KOMITENT.PDVUSISTEMU.SINGULAR" style="color: #777; opacity: 0.5"></span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input
                        [Type]="'text'"
                        name="txtGln"
                        formControlName="Gln"
                        [Label]="'KOMITENT.GLN.SINGULAR'"
                        [MaxLength]="13"
                        ngbTooltip="{{'KOMITENT.GLN.TOOLTIP' | translate }}">
                      </yt-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtPdvBroj" formControlName="PdvBroj"
                        [Label]="'KOMITENT.PDVBROJ.SINGULAR'">
                        [MaxLength]="15"
                      </yt-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group row">
                    <div class="col-lg-12 col-md-12 col-12">
                      <yt-input [Type]="'text'" name="txtBrojPoreskogResenja" formControlName="BrojPoreskogResenja"
                        [MaxLength]="30" [ngClass]="{'is-invalid': submitted && fc.BrojPoreskogResenja.invalid}"
                        [Label]="'KOMITENT.BROJPORESKOGRESENJA.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.BrojPoreskogResenja.invalid">
                        <span *ngFor="let validation of errorMessages.BrojPoreskogResenja">
                          <span class="error-message" *ngIf="fc.BrojPoreskogResenja.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtAdresa" formControlName="Adresa" [MaxLength]="200"
                        [ngClass]="{'is-invalid': submitted && fc.Adresa.invalid}" [Label]="'KOMITENT.ADRESA.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.Adresa.invalid">
                        <span *ngFor="let validation of errorMessages.Adresa">
                          <span class="error-message" *ngIf="fc.Adresa.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-dropdown-picklist [ModelName]="'drzava'" [GetName]="'get'" [ModelProperty]="'Naziv'"
                        formControlName="DrzavaID" [Label]="'KOMITENT.DRZAVA.SINGULAR'" [Position]="'left'"
                        [Required]="true" [AllowAddNew]="false" (OnItemSelected)="onDrzavaSelected($event)"
                        [Width]="'xl'" [Position]="'left'">
                      </yt-dropdown-picklist>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="!inoDrzava">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-autocomplete [ModelName]="'mesto'" [GetName]="'getByNaziv'" [ModelProperty]="'Naziv'"
                        [OrderBy]="'Naziv'" [Label]="'KOMITENT.MESTO.SINGULAR'" formControlName="MestoID"
                        (OnItemSelected)="onMestoSelected($event)"
                        [ShowHeader]="true"
                      >
                      </yt-autocomplete>

                      <div class="form-error" *ngIf="submitted && fc.MestoID.invalid">
                        <span *ngFor="let validation of errorMessages.MestoID">
                          <span class="error-message" *ngIf="fc.MestoID.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="!inoDrzava">
                <div class="form-group row">
                  <!-- <div class="form-group row" *ngIf="fcd && fcd['BrojNarudzbenice'] && fcd['BrojNarudzbenice'].IsVisible"> -->
                      <div class="col-md-12">
                          <yt-input 
                              [Type]="'text'" 
                              [Label]="'KOMITENT.SIFRAFIRMEKODKUPCA.SINGULAR'"
                              formControlName="FirmaSifraKodKupca" 
                              [MaxLength]="50">
                          </yt-input>
                      </div>
                  </div>
                </div>
                <div class="col-md-2" *ngIf="inoDrzava">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'"
                      name="txtOpis" 
                      formControlName="InoOpis"
                      [MaxLength]="500"
                      ngbTooltip="{{'KOMITENT.OPIS.TOOLTIP' | translate }}"
                      [ngClass]="{'is-invalid': submitted && fc.InoOpis.invalid}" [Label]="'KOMITENT.OPIS.SINGULAR'">
                      </yt-input>

                    </div>
                  </div>
                </div>
                <div class="col-md-2" *ngIf="inoDrzava">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtZip" formControlName="InoZip" [MaxLength]="10"
                        [ngClass]="{'is-invalid': submitted && fc.InoZip.invalid}" [Label]="'KOMITENT.ZIP.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.InoZip.invalid">
                        <span *ngFor="let validation of errorMessages.InoZip">
                          <span class="error-message" *ngIf="fc.InoZip.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-md-2" *ngIf="inoDrzava">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtZip" formControlName="InoMesto" [MaxLength]="250"
                        [ngClass]="{'is-invalid': submitted && fc.InoMesto.invalid}"
                        [Label]="'KOMITENT.MESTO.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.InoMesto.invalid">
                        <span *ngFor="let validation of errorMessages.InoMesto">
                          <span class="error-message" *ngIf="fc.InoMesto.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>

                    </div>
                  </div>
                </div>
                <div class="col-md-3" *ngIf="inoDrzava">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" [Label]="'KOMITENT.SIFRAFIRMEKODKUPCA.SINGULAR'"
                        formControlName="FirmaSifraKodKupca" [MaxLength]="50">
                      </yt-input>
                    </div>
                  </div>
                </div>    
                <div class="col-md-2" *ngIf="inoDrzava">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'"
                      name="txtInoPib" 
                      formControlName="InoPib"
                      [MaxLength]="11"
                      ngbTooltip="{{'KOMITENT.INOPIB.TOOLTIP' | translate }}"
                      [ngClass]="{'is-invalid': submitted && fc.InoPib.invalid}" [Label]="'KOMITENT.INOPIB.SINGULAR'">
                      </yt-input>
                      
                    </div>
                  </div>
                </div>            
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtWeb" formControlName="Web" [MaxLength]="50"
                        [Label]="'KOMITENT.WEB.SINGULAR'">
                      </yt-input>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group row">
                    <div class="col-md-12">
                      <yt-input [Type]="'text'" name="txtOdgLice" formControlName="OdgLice" [MaxLength]="100"
                        [ngClass]="{'is-invalid': submitted && fc.OdgLice.invalid}"
                        [Label]="'KOMITENT.ODGLICE.SINGULAR'">
                      </yt-input>
                      <div class="form-error" *ngIf="submitted && fc.OdgLice.invalid">
                        <span *ngFor="let validation of errorMessages.OdgLice">
                          <span class="error-message" *ngIf="fc.OdgLice.hasError(validation.type)"><span
                              translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <div class="form-group row">
                <!-- <label class="col-form-label col-2"><span translate="KOMITENT.NAPOMENA.SINGULAR"></span></label> -->
                <div class="col-md-12">
                  <yt-input [Type]="'text'" name="txtNapomena" formControlName="Napomena" [MaxLength]="2000"
                    [Label]="'KOMITENT.NAPOMENA.SINGULAR'">
                  </yt-input>
                </div>
              </div>

              <!-- <div class="row mb-2">
                <div class="col-md-12">
                  <div class="btn-group float-right">
                    <button type="button" class="btn btn-outline-primary" (click)="SaveItem()" [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable"><span class="fa fa-fa fa-save"></span> Sačuvaj</button>
                    <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()" [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                  </div>
                </div>
              </div> -->
              
            </ng-template>
          </ngb-tab>
          <ngb-tab title="{{'KOMITENTEMAIL.PLURAL'| translate}}" id="tbEmail">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[0]"
                    [ParentPropertyName]="'KomitentID'" [ParentPropertyValue]="Item.ID"
                    [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="{{'KOMITENTTELEFON.PLURAL'| translate}}" id="tbTelefon">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[1]"
                    [ParentPropertyName]="'KomitentID'" [ParentPropertyValue]="Item.ID"
                    [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="{{'KOMITENTZRC.PLURAL'| translate}}" id="tbZrc">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[2]"
                    [ParentPropertyName]="'KomitentID'" [ParentPropertyValue]="Item.ID"
                    [Disabled]="!Item.ID || Item.ID <= 0" #detailList></yt-fw-default-detail-list-modal>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="{{'KOMITENTOBJEKAT.PLURAL'| translate}}" id="tbObjekat">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[3]"
                    [ParentPropertyName]="'KomitentID'" [ParentPropertyValue]="Item.ID"
                    [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
          <ngb-tab title="{{'KOMITENTKONTAKTOSOBA.PLURAL'| translate}}" id="tbKontaktOsoba">
            <ng-template ngbTabContent>
              <div class="row">
                <div class="col-md-12">
                  <yt-fw-default-detail-list-modal [Model]="modelData.MainList.DetailList[4]"
                    [ParentPropertyName]="'KomitentID'" [ParentPropertyValue]="Item.ID"
                    [Disabled]="!Item.ID || Item.ID <= 0"></yt-fw-default-detail-list-modal>
                </div>
              </div>
            </ng-template>
          </ngb-tab>
        </ngb-tabset>
      </div>
    </div>
  </div>
</form>
